import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import SignaturePad from 'react-signature-canvas'
import './App.css';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from "axios";
import Qs from "qs";
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';

var instance = axios.create({
  // timeout: 1000,   //暫不設置timeout
  async: true,
  crossDomain: true,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    "X-Requested-With": "XMLHttpRequest", //for MVC Request.IsAjaxRequest()
  }
});

export default function SigatureDialog(props) {
  const { handleSubmit, open, setOpen, imageURL, setImage, setTime, Update66th } = props;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClear = () => {
    sigPad.current.clear()
  }
  const handleSave = () => {
    if (sigPad.current.isEmpty()) {
      alert("請簽名")
    } else {
      setImage(sigPad.current.getTrimmedCanvas().toDataURL('image/png'));
      // Update66th();
      // const canvas= sigPad.current.getCanvas()
      // canvas.toBlob((blob) => {
      //   const fd = new window.FormData()
      //   fd.append('files', blob, 'signature.png')

      //   instance({
      //     method: "post",
      //     url: 'https://localhost:44311' + "/Questionaire/Upload",
      //     data: fd,
      //   })
      //     .then(function (response) {
      //       console.log(response.data)
      //     })
      //   // POST to server with your preferred requests library
      // })

      handleClose();

    }

    // console.log(dateTime)
    props.setTime(new Date().toLocaleString());

  }
  const sigPad = React.useRef({});


  return (
    <div>
      {!imageURL ? (<Button variant="outlined" color="primary" type="submit" onClick={handleSubmit}>
        <FormattedMessage id={"簽名"} />
      </Button>) : null}
      <Dialog
        open={open}
        fullWidth
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      // maxWidth={"md"}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography><FormattedMessage id={"請簽名(行動裝置請旋轉螢幕為水平橫向)..."} /></Typography>
          <IconButton aria-label="close" onClick={handleClose} style={{ position: "absolute", right: "0", top: "0" }}>
            {/* <CloseIcon /> */}
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <SignaturePad canvasProps={{
            width: 550, height: 240, className: "signatureCanvas"
          }}
            ref={sigPad} />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClear} color="primary">
            <FormattedMessage id={"重新簽名"} />
          </Button>
          <Button variant="contained" onClick={handleSave} color="primary">
            <FormattedMessage id={"確認"} />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}